import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { Button, CheckItem, InputBox } from "../../../components";
import { withRouter } from "react-router-dom";
import { getLanguage } from "../../../utils/environment";
import { CheckValidity } from "../../../utils/formValidity";
import { useDispatch, useSelector } from "react-redux";
import { getAllAdvSubCategory } from "../../CreateNewItem/CreateNewAdvertisement/service/advertisement.service";
import { setNewAdvertisement } from "../../AdsCampaign/redux/actions";
import { Store } from "react-notifications-component";

const StartNewAdCampaign = (props) => {
  const len = getLanguage();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [selectCategory, setSelectCategory] = useState(false);
  const [advCategory, setAdvCategory] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState({});
  const [filteredAdvCategory, setFilteredAdvCategory] = useState([]);
  const [categories, setCategories] = useState([]);

  const [formData, setFormData] = useState({
    campaignName: {
      key: "campaignName",
      label: "Campaign Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "e.g., June Promo for Kidswear",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    categoryName: {
      key: "categoryName",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Search Category",
      },
      touched: false,
      validation: {
        required: false,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { advertisement } = useSelector(
    ({ adsCampaignReducer }) => adsCampaignReducer
  );

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      setFormData(updateForm);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getSubAdvCategory = await getAllAdvSubCategory();

        if (getSubAdvCategory?.data) {
          setAdvCategory(getSubAdvCategory.data);
          setFilteredAdvCategory(getSubAdvCategory.data);

          // Initialize selection state
          const initialSelections = {};
          getSubAdvCategory.data.forEach((item) => {
            initialSelections[item.sub_category_name] = false;
          });
          setSelectedCategories(initialSelections);
        } else {
          console.log("Data Not Found");
        }
      } catch (error) {
        console.log("Error fetching Sub Ad Category", error);
      }
    };
    fetchData();
  }, []);

  const handleToggle = (categoryName, subCategoryId, categoryId) => {
    console.log({ categoryName, subCategoryId, categoryId });
    setSelectCategory(false);
    setSelectedCategories((prev) => ({
      ...prev,
      [categoryName]: !prev[categoryName],
    }));
    let body = {
      category_id: categoryId,
      sub_category_id: subCategoryId,
    };
    setCategories([...categories, body]);
  };

  const getCategoryName = (category_id) => {
    console.log({ category_id });
    if (category_id) {
      const found = advCategory.find(
        (element) => element?.sub_category_id === category_id
      );
      return found?.sub_category_name;
    }
  };

  useEffect(() => {
    const newFormData = { ...formData };

    if (advertisement?.campaignName !== "") {
      newFormData["campaignName"].value = advertisement?.campaignName;
    }
    if (advertisement?.category?.length > 0) {
      setCategories(advertisement?.category);
      console.log({ categories });
      for (let category of advertisement?.category) {
        let subCategoryName = getCategoryName(category?.sub_category_id);
        if (subCategoryName !== "") {
          setSelectedCategories((prev) => ({
            ...prev,
            [subCategoryName]: !prev[subCategoryName],
          }));
        }
      }
    }
    setFormData(newFormData);
  }, [advertisement]);

  // const dispatch = useDispatch();
  const updateForm = { ...formData };

  return (
    <>
      <InputBox
        data={updateForm.campaignName}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateForm.campaignName.key);
        }}
      />
      <div className={"acbw__title"}>Choose Ad Category</div>
      <div className={"acbw__subtitle"}>
        This helps us better target your ad and optimize performance.
      </div>
      <div className={`acwb__form ${selectCategory ? "error" : ""}`}>
        <InputBox
          data={updateForm.categoryName}
          onChange={async (e) => {
            e.preventDefault();
            const inputValue = e.target.value;
            await handleChange(inputValue, updateForm.categoryName.key);

            const filtered = advCategory.filter((item) =>
              item.sub_category_name
                .toLowerCase()
                .includes(inputValue.toLowerCase())
            );
            setFilteredAdvCategory(filtered);
          }}
        />
        {Array.isArray(filteredAdvCategory) &&
        filteredAdvCategory.length > 0 ? (
          filteredAdvCategory.map((item) => (
            <CheckItem
              key={item.sub_category_id}
              data={{
                checkName: item.sub_category_name,
                isActive: selectedCategories[item.sub_category_name],
              }}
              onClick={() =>
                handleToggle(
                  item.sub_category_name,
                  item.sub_category_id,
                  item.category_id
                )
              }
            />
          ))
        ) : (
          <div className="error-message">No Category Found</div>
        )}
      </div>
      <Button
        data={{
          btnName: "Next",
          buttonType: "primary",
          buttonSize: "lg",
          isLoading: isLoading,
        }}
        onClick={async (e) => {
          setIsLoading(true);
          if (updateForm.campaignName.value === "") {
            const newFormData = { ...formData };
            newFormData["campaignName"].touched = true;
            newFormData["campaignName"].isValid = true;
            setFormData(newFormData);
          }
          if (categories?.length === 0) {
            setSelectCategory(true);
          }
          if (updateForm.campaignName.value !== "" && categories?.length > 0) {
            dispatch(
              setNewAdvertisement({
                campaignName: updateForm.campaignName.value,
                category: categories,
                // subCategory: selectedSubCategory,
                placement: "",
                ad_space: "",
                header_banner_img: [],
                right_banner_img: [],
                web_url: "",
                time_schedule: "",
                start_date: "",
                end_date: "",
              })
            );
            props.onNext();
            setIsLoading(false);
          } else {
            const newFormData = { ...formData };
            newFormData["campaignName"].touched = true;
            newFormData["campaignName"].isValid = true;
            setFormData(newFormData);
            setSelectCategory(true);
            Store.addNotification({
              title: "Error!",
              message: "Campaign Name and Category are required!",
              type: "danger",
              insert: "top",
              container: "top-right",
              dismiss: {
                duration: 3000,
                onScreen: true,
              },
            });
            setIsLoading(false);
          }
        }}
      />
    </>
  );
};

export default withRouter(StartNewAdCampaign);
